import { defineComponent as V, openBlock as l, createElementBlock as o, mergeProps as i, unref as e, renderSlot as p, createElementVNode as n, createCommentVNode as u } from "vue";
import { useScalarIcon as m } from "../hooks/useScalarIcon.js";
const Z = { key: 0 }, g = { key: 1 }, M = { key: 2 }, f = { key: 3 }, k = { key: 4 }, h = { key: 5 }, v = {
  name: "ScalarIconMusicNotesSimple"
}, _ = /* @__PURE__ */ V({
  ...v,
  props: {
    label: {},
    weight: {}
  },
  setup(a) {
    const s = a, { bind: r, weight: A } = m(s);
    return (d, t) => (l(), o("svg", i({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, e(r)), [
      p(d.$slots, "default"),
      e(A) === "bold" ? (l(), o("g", Z, t[0] || (t[0] = [
        n("path", { d: "M215.38,14.54a12,12,0,0,0-10.29-2.18l-128,32A12,12,0,0,0,68,56V159.35A40,40,0,1,0,92,196V65.37l104-26v88A40,40,0,1,0,220,164V24A12,12,0,0,0,215.38,14.54ZM52,212a16,16,0,1,1,16-16A16,16,0,0,1,52,212Zm128-32a16,16,0,1,1,16-16A16,16,0,0,1,180,180Z" }, null, -1)
      ]))) : e(A) === "duotone" ? (l(), o("g", g, t[1] || (t[1] = [
        n("path", {
          d: "M208,164a28,28,0,1,1-28-28A28,28,0,0,1,208,164ZM52,168a28,28,0,1,0,28,28A28,28,0,0,0,52,168Z",
          opacity: "0.2"
        }, null, -1),
        n("path", { d: "M212.92,17.69a8,8,0,0,0-6.86-1.45l-128,32A8,8,0,0,0,72,56V166.08A36,36,0,1,0,88,196V62.25l112-28v99.83A36,36,0,1,0,216,164V24A8,8,0,0,0,212.92,17.69ZM52,216a20,20,0,1,1,20-20A20,20,0,0,1,52,216Zm128-32a20,20,0,1,1,20-20A20,20,0,0,1,180,184Z" }, null, -1)
      ]))) : e(A) === "fill" ? (l(), o("g", M, t[2] || (t[2] = [
        n("path", { d: "M212.92,17.69a8,8,0,0,0-6.86-1.45l-128,32A8,8,0,0,0,72,56V166.08A36,36,0,1,0,88,196V62.25l112-28v99.83A36,36,0,1,0,216,164V24A8,8,0,0,0,212.92,17.69Z" }, null, -1)
      ]))) : e(A) === "light" ? (l(), o("g", f, t[3] || (t[3] = [
        n("path", { d: "M211.69,19.27a6,6,0,0,0-5.15-1.09l-128,32A6,6,0,0,0,74,56V170.11A34,34,0,1,0,86,196V60.68l116-29V138.11A34,34,0,1,0,214,164V24A6,6,0,0,0,211.69,19.27ZM52,218a22,22,0,1,1,22-22A22,22,0,0,1,52,218Zm128-32a22,22,0,1,1,22-22A22,22,0,0,1,180,186Z" }, null, -1)
      ]))) : e(A) === "regular" ? (l(), o("g", k, t[4] || (t[4] = [
        n("path", { d: "M212.92,17.69a8,8,0,0,0-6.86-1.45l-128,32A8,8,0,0,0,72,56V166.08A36,36,0,1,0,88,196V62.25l112-28v99.83A36,36,0,1,0,216,164V24A8,8,0,0,0,212.92,17.69ZM52,216a20,20,0,1,1,20-20A20,20,0,0,1,52,216Zm128-32a20,20,0,1,1,20-20A20,20,0,0,1,180,184Z" }, null, -1)
      ]))) : e(A) === "thin" ? (l(), o("g", h, t[5] || (t[5] = [
        n("path", { d: "M210.46,20.85a4,4,0,0,0-3.43-.73l-128,32A4,4,0,0,0,76,56V174.87A32,32,0,1,0,84,196V59.12l120-30V142.87A32,32,0,1,0,212,164V24A4,4,0,0,0,210.46,20.85ZM52,220a24,24,0,1,1,24-24A24,24,0,0,1,52,220Zm128-32a24,24,0,1,1,24-24A24,24,0,0,1,180,188Z" }, null, -1)
      ]))) : u("", !0)
    ], 16));
  }
});
export {
  _ as default
};
